import * as z from 'zod'

// Shared validation schemas to eliminate duplication
export const useFormValidationSchemas = () => {
  // Common domain regex (can be imported from useCreateCompany if needed)
  const DOMAIN_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

  // Shared schema definitions
  const prefixSchema = z
    .string({ required_error: 'Company prefix is required.' })
    .min(3, { message: 'Prefix must be 3 to 7 uppercase letters.' })
    .max(7, { message: 'Prefix must be 3 to 7 uppercase letters.' })
    .regex(/^[A-Z]{3,7}$/, { message: 'Prefix must be 3 to 7 uppercase letters.' })

  const addressSchema = z
    .string({
      required_error: 'Company address is required.',
    })
    .min(1, { message: 'Company address is required.' })

  const phoneSchema = z
    .object({
      country: z.string().nullable().optional(),
      countryCallingCode: z.string().optional(),
      countryCode: z.string().nullable().optional(),
      formatted: z.string().nullable().optional(),
      nationalNumber: z.string().nullable().optional(),
      number: z.string().optional(),
      possible: z.boolean().optional(),
      valid: z.boolean().optional(),
    })
    .refine((val) => val.valid, {
      message: 'Please enter a valid phone number.',
    })
    .nullable()
    .optional()

  const domainsSchema = z
    .array(
      z.string().min(1, { message: 'Domain is required.' }).regex(DOMAIN_REGEX, {
        message: 'Invalid domain format. Example: domain.com',
      }),
    )
    .min(1, { message: 'At least one domain is required.' })

  return {
    prefixSchema,
    addressSchema,
    phoneSchema,
    domainsSchema,
    DOMAIN_REGEX,
  }
}
